import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import htmlReactParser from 'html-react-parser';

import D3Table from './components/organisms/D3-sample-cart-table';

import './D3-sample-cart.scss';

class D3SampleCart extends Component {
	state = {
		products: null,
	}

	componentDidMount() {
		const { data } = this.props;

		if (data.products.length) this.setState({ products: data.products });
	}

	emptyProducts = () => {
		this.setState({ products: null });
	}

	stringifyJSON = () => {
		const { storeProducts } = this.props;
		const cartJSON = JSON.stringify(storeProducts);
		return cartJSON;
	}

	render() {

		const { products } = this.state;
		const { data } = this.props;
		const { content } = data;
		let table = <p className="D3-sample-cart__copy-alert">{content.emptyAlert}</p>;

		if (products) {
			table = <D3Table products={products} emptyCart={this.emptyProducts} labels={content.labels} />;
		}

		return (
			<div className="D3-sample-cart__container container">
				<h2 className="D3-sample-cart__h2">{ htmlReactParser(content.title) }</h2>
				<p className="D3-sample-cart__copy">{ htmlReactParser(content.copy) }</p>
				{ table }
				<input type="hidden" name="json" value={this.stringifyJSON()} />
			</div>
		);
	}
}

D3SampleCart.propTypes = {
	data: PropTypes.shape({}).isRequired,
	storeProducts: PropTypes.arrayOf(PropTypes.shape({})),
};

D3SampleCart.defaultProps = {
	storeProducts: [],
};

const mapStateToProps = (state) => {
	return {
		storeProducts: state.sampleCart.products || null,
	};
};

export default connect(mapStateToProps)(D3SampleCart);
